import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

/**
 * Self-contained refresh notification dialog - uses refs, NO parent re-renders
 * Shows after successful delete operation
 */
const RefreshNotificationDialog: React.FC<{
  dialogRef: React.MutableRefObject<{ open: () => void; close: () => void } | null>;
}> = ({ dialogRef }) => {
  const [open, setOpen] = useState(false);

  // Expose open/close methods via ref (NO parent re-renders)
  useEffect(() => {
    dialogRef.current = {
      open: () => {
        setOpen(true);
      },
      close: () => {
        setOpen(false);
      }
    };
  }, [dialogRef]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="refresh-notification-title"
    >
      <DialogTitle id="refresh-notification-title">
        Delete Successful
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please refresh to see changes.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RefreshNotificationDialog;

